module.exports = __webpack_public_path__ + "bin/52071867f8e39b91b3c59e659f559148.jpg";